import { TextField } from '@mui/material';

type EmailInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  required: boolean;
};

export function EmailInput({ value, onChange, required }: EmailInputProps) {
  return (
    <TextField
      type='email'
      label='E-Mail-Adresse'
      size='small'
      value={value}
      onChange={event =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      fullWidth
      required={required}
    />
  );
}
